<template>
  <div>
    <social-icon provider="pinterest" :url="url" :media="media" :message="message" :caption="caption" :size="21" />
    <social-icon provider="facebook" :url="url" :media="media" :message="message" :caption="caption" :size="21" />
    <social-icon provider="twitter" :url="url" :media="media" :message="message" :caption="caption" :size="21" />
    <social-icon provider="email" :url="url" :media="media" :message="message" :caption="caption" :size="21" />
  </div>
</template>

<script>
import SocialIcon from '@/components/buttons/SocialIcon.vue'
export default {
  components:{
    SocialIcon
  },
  props: {
    url: String,
    media: String,
    message: String,
    caption: String,
  }
}
</script>

<style scoped>
.social-icon{
  margin-right: 9px;
}
</style>
